import FormGroup from '~/components/form/FormGroup';
import { FormHorizontal } from '~/components/form/layout';
import ZodFieldInput from '~/components/zod/ZodFieldInput';
import { useZodFormFieldSingle } from '~/components/zod/ZodForm';
import ZodFieldSelect from '~/components/zod/ZodFieldSelect';
import { PicOrderType } from '~/tenants/pic/model/PicOrder';

function Type() {
  const [_, type] = useZodFormFieldSingle('type');

  if (type) {
    return <></>;
  }

  return (
    <FormHorizontal name="type" label="Type">
      <ZodFieldSelect
        options={[
          {
            label: 'Draft',
            value: PicOrderType.DRAFT,
          },
          {
            label: 'Residential',
            value: PicOrderType.RESIDENTIAL,
          },
          {
            label: 'Commercial',
            value: PicOrderType.COMMERCIAL,
          },
        ]}
        name="type"
      />
    </FormHorizontal>
  );
}

export default function PicOrderForm() {
  const [_, type] = useZodFormFieldSingle('type');

  return (
    <FormGroup>
      <Type />

      {type && type !== PicOrderType.DRAFT && (
        <>
          <FormHorizontal name="sqft" label="Square Feet">
            <ZodFieldInput name="sqft" type="number" autoFocus />
          </FormHorizontal>
          <FormHorizontal name="acres" label="Acres">
            <ZodFieldInput name="acres" type="number" />
          </FormHorizontal>
        </>
      )}
    </FormGroup>
  );
}
